import React from 'react';
import uuid from '../../../core/components/UniqueHash';
import { useModal } from '../../../../../hooks/Modal';

import api from '../../../../../services/api';
import { useToast } from '../../../../../hooks/Toast';
import { useSearch } from '../../../../../hooks/Search';
import { FaEdit, FaNewspaper, FaUpload } from 'react-icons/fa';
 
import { useLoading } from '../../../../../hooks/LoadingHook';



export default function UpdateModule({lineData}): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const {addLoading, removeLoading} = useLoading();
  const key = uuid();

  const uploadContacts = async ( ) => {

 addLoading({title:'Distribuindo Avaliações', key:'loading'})



try{

    await api.post(`/apply-papers-to-simple-avaliations-to-all/${lineData?._id?.toString()}` );
  addToast({title:'Distribuido com sucesso', type:'success'});
  removeLoading('loading');
 
}
catch(err){
    removeLoading('loading');
  addToast({title:'Erro ao distribuir', type:'error'})
  
}

  }
 

  const moduleUpdate = (): JSX.Element => (
    <button className="lineIcon" title="Distribuir avaliações" type="button" onClick={() => uploadContacts()}>
      <FaNewspaper />
    </button>
  );

  return moduleUpdate();
}
